var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetaverse601(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22.43 16.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{mix-blend-mode:multiply;opacity:0.4;}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:#080749;}.cls-6{fill:#ffd1a4;}.cls-7{fill:#300e70;}.cls-8{fill:#e5ae80;}.cls-9{fill:#f2ba88;}.cls-10{fill:url(#linear-gradient-2);}.cls-11{fill:#468fb7;}.cls-12{fill:#5ca4d6;}.cls-13{fill:#caeaff;}.cls-14{fill:#98cbf3;}.cls-15{fill:#f6f9ff;}.cls-16{fill:url(#linear-gradient-3);}.cls-17,.cls-24,.cls-52,.cls-53{mix-blend-mode:screen;}.cls-18{fill:url(#linear-gradient-4);}.cls-19{fill:url(#linear-gradient-5);}.cls-20{fill:url(#linear-gradient-6);}.cls-21{fill:url(#linear-gradient-7);}.cls-22{fill:url(#linear-gradient-8);}.cls-23{fill:url(#linear-gradient-9);}.cls-24,.cls-52,.cls-53,.cls-54{opacity:0.5;}.cls-25{fill:url(#linear-gradient-10);}.cls-26{fill:url(#linear-gradient-11);}.cls-27{fill:url(#linear-gradient-12);}.cls-28{fill:url(#linear-gradient-13);}.cls-29{fill:url(#linear-gradient-14);}.cls-30{fill:url(#linear-gradient-15);}.cls-31{fill:url(#linear-gradient-16);}.cls-32{fill:url(#linear-gradient-17);}.cls-33{fill:url(#linear-gradient-18);}.cls-34{fill:url(#linear-gradient-19);}.cls-35{fill:url(#linear-gradient-20);}.cls-36{fill:url(#linear-gradient-21);}.cls-37{fill:url(#linear-gradient-22);}.cls-38{fill:url(#linear-gradient-23);}.cls-39{fill:url(#linear-gradient-24);}.cls-40{fill:#e1efff;}.cls-41{fill:url(#linear-gradient-25);}.cls-42{fill:url(#linear-gradient-26);}.cls-43{fill:url(#linear-gradient-27);}.cls-44{fill:url(#linear-gradient-28);}.cls-45{fill:url(#linear-gradient-29);}.cls-46{fill:url(#linear-gradient-30);}.cls-47{fill:url(#linear-gradient-31);}.cls-48{fill:url(#linear-gradient-32);}.cls-49{fill:url(#linear-gradient-33);}.cls-50{fill:url(#linear-gradient-34);}.cls-51{fill:url(#linear-gradient-35);}.cls-52{fill:url(#linear-gradient-36);}.cls-53{fill:url(#linear-gradient-37);}.cls-54,.cls-55{fill:none;stroke-miterlimit:10;}.cls-54{stroke:#fff;stroke-width:0.14px;}.cls-55{stroke:url(#linear-gradient-38);}.cls-56{fill:url(#linear-gradient-39);}.cls-57{fill:url(#linear-gradient-40);}.cls-58{fill:#fffff9;}.cls-59{fill:url(#linear-gradient-41);}.cls-60{fill:url(#linear-gradient-42);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12.13,
    y1: 15.55,
    x2: 7.37,
    y2: 12.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00fffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00aee5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 8.24,
    y1: 7.53,
    x2: 8.53,
    y2: 4.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9df4ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9df4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 184.78,
    y1: 1.51,
    x2: 186.14,
    y2: 1.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 192.77, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 15.18,
    y1: 8.06,
    x2: 15.98,
    y2: 8.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00bbf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f3fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 15.56,
    y1: 8.39,
    x2: 15.98,
    y2: 8.39,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 15.18,
    y1: 8.4,
    x2: 15.56,
    y2: 8.4,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 13.11,
    y1: 13.87,
    x2: 14.2,
    y2: 13.87,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 13.63,
    y1: 14.32,
    x2: 14.2,
    y2: 14.32,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 13.11,
    y1: 14.34,
    x2: 13.63,
    y2: 14.34,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 12.23,
    y1: 8.18,
    x2: 13.04,
    y2: 8.18,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 12.62,
    y1: 8.51,
    x2: 13.04,
    y2: 8.51,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 12.23,
    y1: 8.52,
    x2: 12.62,
    y2: 8.52,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 11.35,
    y1: 0.27,
    x2: 12.15,
    y2: 0.27,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 11.73,
    y1: 0.6,
    x2: 12.15,
    y2: 0.6,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 11.35,
    y1: 0.61,
    x2: 11.73,
    y2: 0.61,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 7.07,
    y1: 12.36,
    x2: 7.57,
    y2: 12.36,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 7.31,
    y1: 12.56,
    x2: 7.57,
    y2: 12.56,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 7.07,
    y1: 12.57,
    x2: 7.31,
    y2: 12.57,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 16.51,
    y1: 4.54,
    x2: 17,
    y2: 4.54,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 16.75,
    y1: 4.75,
    x2: 17,
    y2: 4.75,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 16.51,
    y1: 4.76,
    x2: 16.75,
    y2: 4.76,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 5.43,
    y1: 8.88,
    x2: 6.58,
    y2: 8.88,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 5.98,
    y1: 9.36,
    x2: 6.58,
    y2: 9.36,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 5.43,
    y1: 9.38,
    x2: 5.98,
    y2: 9.38,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 10.62,
    y1: 6.28,
    x2: 13.67,
    y2: 6.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0089e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003bd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 12.5,
    y1: 12.01,
    x2: 14.52,
    y2: 12.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 12.63,
    y1: 11.6,
    x2: 14.38,
    y2: 11.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 12.5,
    y1: 11.51,
    x2: 14.52,
    y2: 11.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 14.43,
    y1: 10,
    x2: 15.31,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0075ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 11.55,
    y1: 9.7,
    x2: 12.49,
    y2: 9.7,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 13.44,
    y1: 10.52,
    x2: 15.18,
    y2: 10.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "aqua"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 13.57,
    y1: 11.34,
    x2: 12.31,
    y2: 9.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "aqua"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 12.98,
    y1: 11.36,
    x2: 13.56,
    y2: 11.36,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -15.72,
    y1: 182.27,
    x2: -14.76,
    y2: 182.27,
    gradientTransform: "translate(83.96 -156.82) rotate(18.13)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 13.4,
    y1: 11.93,
    x2: 13.98,
    y2: 11.93,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 14.55,
    y1: 5.5,
    x2: 7.54,
    y2: 5.5,
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 727.33,
    y1: 6.34,
    x2: 728.3,
    y2: 4.65,
    gradientTransform: "matrix(-1, 0, 0, 1, 738.43, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "aqua",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "aqua"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 723.93,
    y1: -56.1,
    x2: 730.84,
    y2: -56.1,
    gradientTransform: "matrix(-1, 0.58, 0, 1, 738.43, -359.08)",
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 10.38,
    y1: 4.62,
    x2: 10.54,
    y2: 4.62,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 778.83,
    y1: 5.78,
    x2: 780.78,
    y2: 5.78,
    gradientTransform: "matrix(-1, 0, 0, 1, 794.71, 0)",
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 695.13,
    y1: 8.7,
    x2: 697.39,
    y2: 8.7,
    gradientTransform: "matrix(-1, -0.02, 0, 1, 710.15, 5.15)",
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 10.28,
    y1: 0.43,
    x2: 9.06,
    y2: 4.7,
    xlinkHref: "#linear-gradient-31"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("image", {
    width: 79,
    height: 76,
    transform: "translate(-29.57 -22.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABMCAYAAAAsoOooAAAACXBIWXMAAAsSAAALEgHS3X78AAAEwklEQVR4Xu2a3U7cRhSAvzMz3r8A6RIRlUitelG1EqhXvEBeguch+zy8BH0ALuEqF1ErQSVCCCELrD0zpxfePwIoVUexaTWfZO14PWuvP5/xzBxbVJXMv8N8rULmcbK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BLK8BNzXKjSNiAg8/BaD6iMbWkKewusWIgiwcDYayb1Ke3v11umWpyCyVXnzKFNgNNVytC/s7j5Qex+Od+s/u8dcZJsSW5M3F/dmJLAHWwjHCJuHwmn/fuRt3iinO8oWyjELiS0KbKXDWIhDONoSODBcYDh/azl9YVlbs3DjYFgva2v19+tvLRcYwLCFMELQpWbfMK1EngjCm1EtbntX4NjAwEDXwIWh/1LoG+H6ozD4TrmJyooqzkc6k8iz68jGVuRsGoV7qD7Wy3xDGo88kTpaYA+2NxbiPn+yMHYwcBS3BeX7Dq5fUE469XrhmIwd7/uW8cBwdmw4XkRcG9HXzlBlhHCEMFwVXk3FrQws9BwdZ/G3Fu0b8HX9GCK924DvBboFvJ/uZxNliDACWrjvtSMPYPtA4KXAucGsGCgdiKNUR+xYemKwIgRV+jYSK0O/I9xcw3pPKbvKkDiNvsbFQcPNVkTqJnu0L5ysCucd4XMhrBcGhobCWXqVw/oCEwoqX2BcQekKonMYa3lmDd4a+kb4a9o7b+1Lvf9mm27DkfdFgLxwAk746Ay9a0OlllhYusYSrUURolcKFzBGmUwihQvoleGqL6y+E8odYOfBo31rGpY3YzYIfgdsQO9MKPqCRkErg0YD0dSjuI6ilaLBYK3gRBAjrAHjnx49QhM02mzvcrgodlcWIek6ddkWiusodjqWct1FnXK1lXvcl7Qkb3+pfAaTqFRRoRshRooiUGoEjYjW6xIjphvxqvRVOYM6cpcuQsM0Kk+1bohs7yqvdpRzrzCMsBbp9AIdHwghIM4jwWOWlhgDMQYGg0ARI85Hrrzyy858utb0NK1ReXc5gBelcvlOIUTKKmC6no6tUF9hbTlfKCooKpz3xBC4DJFxUL4vld8Pvnagb0ZL8kZwdKac3Ch+I8Ifkf4kYCceX1SESYV1JRNXUrkSfIX2Kjp9T/QB5yPuNnJxo2y9VhjR7CClpvG57Z2kwBbCxaFh8tzw4dKy8aPh6srSXRf08+LCykpk8EHxq7W4HzYDfxKng2StsyuCNnwyjUfe/AT3ppP60yulexlZfx6YvA0M+xWXJ55ut6QaV3S7JZ0TD/2KySQwGdfiTg90IY7GxUEL8mCp42AEvI4MdyIffg58el7LYeAZjD0vf60YjD1nA89kHPj0KfDbz4EhEV7H+vfNdxQzGm+2y8wzLCNknkGeJUTvzBoOmSdCZxnlaTa5jVTUjFblwXKKisdT8fv79fAGnkwKHp6AvBn3HgI9WKn+aFvajCcjb5n7jx+b70n/CU9S3n+FVnrb/wtZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJZXgJ/A/66Fn0BrpKTAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.38,14.28v.25c0,.87,1.16,1.58,2.59,1.58s2.6-.71,2.6-1.58v-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.57,14.28c0,.88-1.16,1.58-2.6,1.58s-2.59-.7-2.59-1.58S8.54,12.7,10,12.7,12.57,13.41,12.57,14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.61,14.1l-1.49-.38a.39.39,0,0,0,0,.11,2.33,2.33,0,0,0,.31.14h.06l.15.11a1.84,1.84,0,0,0,.37.19.94.94,0,0,0,.45.05C11.6,14.28,11.64,14.16,11.61,14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.25,13.15s-.14.06-.15.5a.15.15,0,0,0,.05.11s.21.08.32.15a2.77,2.77,0,0,0,.66.35.55.55,0,0,0,.48-.06.2.2,0,0,0-.08-.25,5,5,0,0,1-.62-.59,2.07,2.07,0,0,0-.22-.22S10.34,13.2,10.25,13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.22,12.77a4.26,4.26,0,0,1,0,.43c0,.09.39.15.5,0s0-.22,0-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M10,6.42s-.67.54-.66,1A20.88,20.88,0,0,0,10,10.15a3.6,3.6,0,0,0,0,1c0,.48.17,1.88.17,1.88a.58.58,0,0,0,.44.14c.11,0,.23,0,.23-.13s.2-2.37.24-2.8a24.13,24.13,0,0,0-.34-3.5C10.69,6.5,10,6.42,10,6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M9.91,15.12l-1.49-.38a.39.39,0,0,0,0,.11,3.11,3.11,0,0,0,.31.14h.06l.15.1a1.43,1.43,0,0,0,.37.19,1,1,0,0,0,.46.05A.16.16,0,0,0,9.91,15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.55,14.18s-.14.05-.15.49a.19.19,0,0,0,0,.11c.05,0,.21.08.32.15a2.19,2.19,0,0,0,.66.35.55.55,0,0,0,.48-.06c.05-.06,0-.17-.08-.24a7,7,0,0,1-.62-.59A1.37,1.37,0,0,0,9,14.17S8.64,14.22,8.55,14.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8.52,13.8s0,.33,0,.43.38.14.49,0,0-.21,0-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M8.34,7.44a1.87,1.87,0,0,0-.24.88,3.79,3.79,0,0,0,.17,1A10.88,10.88,0,0,1,8.32,11a5,5,0,0,0,0,1.18c0,.49.16,1.89.16,1.89a.75.75,0,0,0,.37.13c.13,0,.29,0,.31-.12s.17-2.35.23-2.8c.11-.87.52-3.74.52-3.95S8.34,7.44,8.34,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.27,4.68s.3.57.41.73.35.31,1,.52,1,.3,1,.3l.1-.32s-.67-.37-1-.57L11.34,5l-.19-.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.91,3a10.85,10.85,0,0,1,.38,1.24,1.92,1.92,0,0,1-.73.41C10.07,4.83,10.91,3,10.91,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.71,6.67s0,0,0,0a.31.31,0,0,1-.13.26,5.37,5.37,0,0,1-1.46.73h0a3.28,3.28,0,0,1-.48,0h0c-.3,0-.37-.14-.38-.23h0V7.44a1.8,1.8,0,0,1,.07-.38.29.29,0,0,1,0-.09l0-.11,0-.06a.09.09,0,0,1,0,0A2.51,2.51,0,0,0,8.1,5.4C8.06,5.27,8,5.15,8,5c-.08-.27-.16-.53-.22-.79,0,0,0-.06,0-.08a1.51,1.51,0,0,1-.06-.41.73.73,0,0,1,0-.12c0-.06.06-.11.08-.16A1.8,1.8,0,0,1,8,3.26H8L8,3.2l.13-.1L8.26,3l0,0h0l0,0,.06,0,.06,0,.11-.06a2.64,2.64,0,0,1,.36-.16l.11,0,.07,0,.33-.08.52-.1a1.39,1.39,0,0,1,.42,0,.82.82,0,0,1,.54.56s0,.07,0,.11a21.12,21.12,0,0,0-.22,3.49v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M9.84,2.7s.21.2,0,.35l-.09-.21.09-.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M9,2l0,.81s.61.47.85.27c0-.14,0-.48,0-.68l-.23-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.33,1.35a2.43,2.43,0,0,1-.05.74c-.08.36-.1.44-.24.51a.49.49,0,0,1-.52-.09,1.24,1.24,0,0,1-.37-.41s0,0-.13-.07a.55.55,0,0,1-.16-.44A1.38,1.38,0,0,1,9.08.85c.16-.27.65-.18.88-.07A.78.78,0,0,1,10.33,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M10.4,1.51h0a.73.73,0,0,1-.63-.1.1.1,0,0,0-.1.1c-.05.19-.18.21-.24.25S9.34,2,9.34,2H9.26a1.23,1.23,0,0,0,0-.28.15.15,0,0,0-.27,0c-.07.11,0,.24,0,.34v.07a.91.91,0,0,1-.22-.63h0c0-.14-.12-.27,0-.49S9,.84,9.05.8A.63.63,0,0,1,9.82.51a.42.42,0,0,1,.24.18.32.32,0,0,1,.25.2C10.73,1.12,10.68,1.41,10.4,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M8.65,6.44a1.52,1.52,0,0,1,0,.37,3,3,0,0,0,0,1h0c-.3,0-.37-.14-.38-.23h0V7.44a1.8,1.8,0,0,1,.07-.38.29.29,0,0,1,0-.09h0l0-.11,0-.06a.09.09,0,0,1,0,0A2.51,2.51,0,0,0,8.1,5.4c0-.25.05-.53.05-.56a7.16,7.16,0,0,1,.51-.64A11.34,11.34,0,0,0,8.65,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.45,4.54s-.24,1.16-.24,1.3.39.22.66.15.54-1.16.54-1.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.07,3.4a3.88,3.88,0,0,1,1-.62V2.6A4.6,4.6,0,0,0,8,3.26H8a1.8,1.8,0,0,0-.16.21,3.33,3.33,0,0,0-.26.67c0,.09,0,.17-.08.27s-.1.37-.14.55a.52.52,0,0,0,.15.11,2.94,2.94,0,0,0,.84.29h0A5.17,5.17,0,0,0,8.75,4C8.75,3.59,8.34,3.4,8.07,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M9.46,1.89v.29s-.58-.27-.66-.42a.79.79,0,0,1,0-.23.09.09,0,0,1,0-.07l0,0s0,.05,0,.06A1.81,1.81,0,0,0,9.46,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M9.46,1.89v0A2.14,2.14,0,0,1,9,1.73a1.4,1.4,0,0,1-.26-.21.07.07,0,0,1,0-.06l0,0a.18.18,0,0,0,0,.06A1.81,1.81,0,0,0,9.46,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M10.45,1.63h0a.36.36,0,0,0-.11,0l0,0a.11.11,0,0,1-.05.05,1.52,1.52,0,0,1-.5.18.87.87,0,0,1-.28-.07,0,0,0,0,0,0,0s0,0,0,0L9.56,2a1,1,0,0,0,.36,0,1,1,0,0,0,.57-.3S10.46,1.64,10.45,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M9.42,1.83a1.29,1.29,0,0,0,0,.36.83.83,0,0,0,.32.18,1.79,1.79,0,0,0,.65-.27A.19.19,0,0,0,10.44,2a.92.92,0,0,0,.05-.36A2.35,2.35,0,0,1,9.75,2,.77.77,0,0,1,9.42,1.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "7.66 2.32 7.5 2.23 7.39 2.01 7.51 2.03 7.66 2.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M6.6,1.14,7.71.5a.08.08,0,0,1,.08,0h0l.15.06,0,.06H7.86v1a.22.22,0,0,1-.1.18l-1.08.62h0v.09l-.16-.06h0a.09.09,0,0,1-.06-.08v-1A.23.23,0,0,1,6.6,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M6.76,1.2,7.88.56A.08.08,0,0,1,8,.63v1a.2.2,0,0,1-.11.18l-.1.06-.13.45L7.51,2h0l-.75.43a.08.08,0,0,1-.13-.07v-1A.24.24,0,0,1,6.76,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.64,1.21a.22.22,0,0,0-.1.17c0,.06,0,.09.1.06a.22.22,0,0,0,.09-.17C7.73,1.21,7.69,1.18,7.64,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.32,1.4a.21.21,0,0,0-.1.17c0,.06,0,.08.1.05a.2.2,0,0,0,.09-.16C7.41,1.39,7.37,1.37,7.32,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7,1.59a.2.2,0,0,0-.09.16c0,.06,0,.09.09.06a.21.21,0,0,0,.1-.17C7.09,1.58,7.05,1.55,7,1.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "15.98 8.05 15.56 8.3 15.18 8.07 15.6 7.81 15.98 8.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "15.56 8.3 15.56 8.74 15.98 8.48 15.98 8.05 15.56 8.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "15.18 8.07 15.18 8.5 15.56 8.74 15.56 8.3 15.18 8.07"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "14.2 13.85 13.63 14.2 13.11 13.88 13.68 13.53 14.2 13.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "13.63 14.2 13.63 14.79 14.2 14.45 14.2 13.85 13.63 14.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "13.11 13.88 13.11 14.47 13.63 14.79 13.63 14.2 13.11 13.88"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "13.04 8.17 12.62 8.42 12.23 8.19 12.65 7.93 13.04 8.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "12.62 8.42 12.62 8.86 13.04 8.6 13.04 8.17 12.62 8.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "12.23 8.19 12.23 8.62 12.62 8.86 12.62 8.42 12.23 8.19"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "12.15 0.26 11.73 0.51 11.35 0.28 11.76 0.02 12.15 0.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "11.73 0.51 11.73 0.95 12.15 0.69 12.15 0.26 11.73 0.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "11.35 0.28 11.35 0.71 11.73 0.95 11.73 0.51 11.35 0.28"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "7.57 12.35 7.31 12.51 7.07 12.36 7.33 12.2 7.57 12.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "7.31 12.51 7.31 12.78 7.57 12.62 7.57 12.35 7.31 12.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "7.07 12.36 7.07 12.63 7.31 12.78 7.31 12.51 7.07 12.36"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "17 4.54 16.75 4.7 16.51 4.55 16.77 4.39 17 4.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "16.75 4.7 16.75 4.97 17 4.81 17 4.54 16.75 4.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "16.51 4.55 16.51 4.82 16.75 4.97 16.75 4.7 16.51 4.55"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "6.58 8.87 5.98 9.24 5.43 8.89 6.03 8.53 6.58 8.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "5.98 9.24 5.98 9.86 6.58 9.49 6.58 8.87 5.98 9.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "5.43 8.89 5.43 9.52 5.98 9.86 5.98 9.24 5.43 8.89"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.42,6.13l-.25,0L10,6.47c.08,0,.14.13.23.15l.17,0a.06.06,0,0,0,0,.08s.2.07.27.08a.26.26,0,0,0,.21-.13.42.42,0,0,0,.07-.31.72.72,0,0,0-.13-.15.8.8,0,0,0-.22-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11.25,6.52c.12,0,.16,0,.14,0l-.61-.32-.19,0h0a1.54,1.54,0,0,1,.17.24l.24,0A2.2,2.2,0,0,0,11.25,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11.24,5.77,12,6l.25-.46-.67-.41C11.49,5.1,11.24,5.77,11.24,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M13.65,4.57l-.12-.09h0l-1.67,1a.29.29,0,0,0-.11.11L10.5,7.83s0,0,0,0l.12.09.17-.21L12.2,7a.3.3,0,0,0,.08-.08l1.17-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M13.66,4.61,12.4,7a.16.16,0,0,1-.08.08L10.69,8a0,0,0,0,1-.07-.06l1.22-2.3a.35.35,0,0,1,.11-.1l1.67-.95A0,0,0,0,1,13.66,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M13,5.83,12.75,6c-.06,0-.24.12-.25.19s0,0,0,0-.11.08-.12.12,0,0,.07,0a0,0,0,0,0,0,0s0,0,0,0,.13,0,.15,0l0,0C12.79,6.35,13.08,6,13,5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.36,5s-.25,1-.13,1.21c.23.31,2.89.25,2.89.25l.23-.32L8.1,5.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M14.52,11.56a1,1,0,0,0-.74-.57l-.25,0h-.2a.93.93,0,0,0-.69.35l-.14.24.31,1.15v-.06a.35.35,0,0,0,.2.26,1.1,1.1,0,0,0,1,0,.38.38,0,0,0,.2-.26h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 13.51,
    cy: 11.6,
    rx: 0.86,
    ry: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M14.22,11.1a1.57,1.57,0,0,0-1.43,0,.43.43,0,0,0,0,.82,1.57,1.57,0,0,0,1.43,0C14.62,11.69,14.62,11.32,14.22,11.1Zm-1.34.77a.38.38,0,0,1,0-.72,1.38,1.38,0,0,1,1.25,0c.35.2.35.52,0,.72A1.38,1.38,0,0,1,12.88,11.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M14.43,9.87s.68,0,.81.52a.55.55,0,0,0-.06-.63C14.78,9.37,14.43,9.87,14.43,9.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M11.69,9.49a.67.67,0,0,0-.12.53s.39-.78.92-.47A.68.68,0,0,0,11.69,9.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M13.47,11.61a2.41,2.41,0,0,1,.47-1.89c.34-.3.66-.37.88-.2a.61.61,0,0,1,.36.24s-.14-.14-.45,0a2.53,2.53,0,0,0-1.17,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M13.47,11.61s-.72-2.71-1.78-2.12a.68.68,0,0,1,.39-.22.36.36,0,0,1,.31-.07,2.07,2.07,0,0,1,1.17,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M13.43,11.21a.82.82,0,0,1,.13.4h-.09a.76.76,0,0,0-.49-.36C13.27,11,13.43,11.21,13.43,11.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M13.35,11.09a.36.36,0,0,1,.08.12s-.09-.11-.3,0a1.47,1.47,0,0,0-.83,1.16s-.18-.87.26-1.26A.57.57,0,0,1,13.35,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M13.4,11.44s0-.16.24-.15c.08,0,.2,0,.25.06a1.77,1.77,0,0,1-.08,1.23s-.09-.33-.19-.63S13.4,11.56,13.4,11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M7.39,10l7.06-4.08a.23.23,0,0,0,.12-.2V1.09A.11.11,0,0,0,14.41,1l-7,4.05a.3.3,0,0,0-.15.26V9.93A.09.09,0,0,0,7.39,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M7.67,7.26c.29-.21.46-.62.82-.78s.6.11,1-.33.57-1.27,1-1.51.62.91,1.31.27a13.33,13.33,0,0,1,1.2-1.1,1.34,1.34,0,0,1,1.22-.29V4.75L7.67,8.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 14.16,
    y1: 3.52,
    x2: 14.16,
    y2: 4.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 13.25,
    y1: 3.63,
    x2: 13.25,
    y2: 5.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 12.32,
    y1: 4.36,
    x2: 12.32,
    y2: 5.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 11.39,
    y1: 5.12,
    x2: 11.39,
    y2: 6.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 10.46,
    y1: 4.64,
    x2: 10.46,
    y2: 6.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 9.53,
    y1: 6.07,
    x2: 9.53,
    y2: 7.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 8.6,
    y1: 6.44,
    x2: 8.6,
    y2: 7.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 7.67,
    y1: 7.26,
    x2: 7.67,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M14.16,3.52a1.34,1.34,0,0,0-1.22.29,13.33,13.33,0,0,0-1.2,1.1c-.69.64-.79-.56-1.31-.27s-.62,1.09-1,1.51-.6.16-1,.33-.53.57-.82.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M10.38,4.67s0,.06.08,0a.16.16,0,0,0,.08-.12,0,0,0,0,0-.08,0A.16.16,0,0,0,10.38,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M14,5.27l1.63-.93a.09.09,0,0,1,.1,0h0l.12.06-.07.1h0V5.93a.21.21,0,0,1-.11.19L14,7.1l0,0v0l-.12-.07a.12.12,0,0,1,0-.08V5.56A.34.34,0,0,1,14,5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M13.93,5.63V7.08a.1.1,0,0,0,.15.08l1.69-1A.21.21,0,0,0,15.88,6V4.49a.1.1,0,0,0-.15-.09l-1.63.94A.34.34,0,0,0,13.93,5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M15.34,5.68l-.58.62a0,0,0,0,1-.06,0V5.35a0,0,0,0,1,.05,0l.58.3S15.35,5.66,15.34,5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.94,7.52h0l1.89-1.08s0,0,0-.06a0,0,0,0,0-.06,0l-1.9,1.09s0,0,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.94,7.82h0l1-.57a0,0,0,0,0,0-.06,0,0,0,0,0-.05,0l-1,.57a0,0,0,0,0,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.18,7.11h0l.66-.38a0,0,0,0,0,0-.06s0,0-.06,0L15.16,7s0,0,0,0S15.17,7.11,15.18,7.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.94,8.15h0l1.21-.69s0,0,0-.06,0,0-.06,0l-1.22.7s0,0,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M12.56,2.35a.15.15,0,0,1,0-.07.62.62,0,0,1,.28-.38l.07,0A1,1,0,0,1,13,1.65a1,1,0,0,1,.28-.31,1.45,1.45,0,0,1,.57-.7.46.46,0,0,1,.47-.05h0l.15.08.1,0a.18.18,0,0,1,.13,0h0l.21.13h0a.21.21,0,0,1,.08.18.82.82,0,0,1-.39.61l-1.59.93a.24.24,0,0,1-.21,0h0l-.2-.13h0A.15.15,0,0,1,12.56,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M13.05,2l.07,0a1,1,0,0,1,.38-.52,1.36,1.36,0,0,1,.56-.71c.29-.16.54-.11.6.12.2-.1.37,0,.37.17a.82.82,0,0,1-.39.61l-1.59.93c-.16.09-.28,0-.28-.12A.57.57,0,0,1,13.05,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M10.43,3.33c0-.1-.07-.14-.15-.09L7.93,4.59a.36.36,0,0,0-.15.27v.43A.16.16,0,0,0,8,5.44l2.13-1.23a.1.1,0,0,1,.09,0l.13.08h0a.08.08,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "10.04 3.55 10.04 3.65 8.12 4.75 8.12 4.66 10.04 3.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "10.04 3.89 10.04 3.98 8.12 5.09 8.12 4.99 10.04 3.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "9.49 4.37 9.49 4.46 8.12 5.25 8.12 5.16 9.49 4.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "9.7 3.92 9.08 4.27 9.08 4.37 9.7 4.01 9.7 3.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "8.12 4.83 8.12 4.92 8.98 4.42 8.98 4.33 8.12 4.83"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverse601);
export default __webpack_public_path__ + "static/media/metaverse6-01.01d8a1ed7a99ba55447e6efeecab4e82.svg";
export { ForwardRef as ReactComponent };